<div class="confirm-dialog">
  <h2 class="headline">{{ header }}</h2>
  <p class="description">{{ description }}</p>
  <div class="btn-block">
    <button
      [class.btn-danger]="state"
      [class.btn-accent]="!state"
      (click)="confirmEvent()"
      class="btn">
      {{ buttonText }}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">{{ 'BUTTONS.CANCEL' | translate }}
    </button>
  </div>
</div>
